import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4966899f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap col-12 align-items-center" }
const _hoisted_2 = { class: "line-title" }
const _hoisted_3 = {
  style: {"white-space":"nowrap"},
  class: "d-flex align-items-center col"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-visual" }, null, -1))
const _hoisted_5 = { class: "mb-0 mt-2 h2" }
const _hoisted_6 = { class: "register-form py-2 py-lg-3" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "d-flex flex-column flex-wrap" }
const _hoisted_9 = { class: "d-flex flex-column flex-wrap" }
const _hoisted_10 = { class: "d-flex flex-column flex-wrap" }
const _hoisted_11 = {
  name: "mobileNumber",
  class: "mimic-input text-truncate"
}
const _hoisted_12 = { class: "mb-3 row flex-wrap gy-2" }
const _hoisted_13 = { class: "col-auto" }

import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { reactive, ref, Ref } from "vue";
import { ValidateFieldsError } from "async-validator";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { handleInvalidForm } from "@/utilities/api";
import { useMiscStore } from "@/stores/misc";

// test data
// 0828245092
// VLTE0002106

type RegisterFormOne = {
  mobileNumber: string,
  orderReferenceNumber: string,
}

type RegisterFormTwo = {
  otp: string,
  mobileNumber: string
}

type RegisterFormThree = {
  email: string,
  mobileNumber: string,
  customerId: string,
  password: string,
  confirmPassword: string
}

type Process = {
  refs: {
    one: Ref<FormInstance | null>,
    two: Ref<FormInstance | null>,
    three: Ref<FormInstance | null>
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterForm',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();
const stepOneFormRef = ref<FormInstance | null>(null);
const stepTwoFormRef = ref<FormInstance | null>(null);
const stepThreeFormRef = ref<FormInstance | null>(null);
let formOneData = reactive<RegisterFormOne>({ 
  mobileNumber: "",
  orderReferenceNumber: "",
});
let formTwoData = reactive<RegisterFormTwo>({
  mobileNumber: '',
  otp: ''
})
let formThreeData = reactive<RegisterFormThree>({ 
  email: "",
  mobileNumber: "",
  password: "",
  confirmPassword: "",
  customerId: ""
});
let currentStep = ref<'one' | 'two' | 'three'>('one');
let process: Process = {
  refs: {
    one: stepOneFormRef,
    two: stepTwoFormRef,
    three: stepThreeFormRef
  }
}
let stepAsNumber = {
  one: 1,
  two: 2,
  three: 3
}

let formDetails = {
  one: {
    title: 'Confirm Cellphone Number',
    description: `Enter your cellphone number and order reference number below to receive a one time password (OTP):`,
    submit: 'Send OTP'
  },
  two: {
    title: 'Verify OTP',
    description: `An OTP has been send to your cellphone number. Enter the OTP below:`,
    submit: 'Verify OTP'
  },
  three: {
    title: 'Register Account',
    description: `Complete your details below to create your account:`,
    submit: 'Register'
  }
}
const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(.{8,})$/;

const validatePassword = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('Please enter a password'))
  } else if(!passwordRegex.test(value)){
    callback(new Error('Minimum 8 characters: 1 uppercase, 1 lowercase, 1 symbol and 1 number'))
  } else {
    if (formThreeData.confirmPassword !== '') {
      if (!process.refs[currentStep.value].value) return
      process.refs.three.value?.validateField('confirmPassword', () => null)
    }
    callback()
  }
}

const validatePassword2 = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('Please confirm the password'))
  } else if (value !== formThreeData.password) {
    callback(new Error("The passwords do not match"))
  } else {
    callback()
  }
}

const rulesStepOne = reactive<FormRules<RegisterFormOne>>({
  mobileNumber: [
    { required: true, message: "Please enter a cellphone number", trigger: "change" },
    { pattern: /^0\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s?$/, message: "Please enter a valid cellphone number (no country code)", trigger: "blur" },
  ],
  orderReferenceNumber: [{ required: true, message: "Please enter a valid order reference", trigger: "change" }],
});

const rulesStepTwo = reactive<FormRules<RegisterFormTwo>>({
  otp: [{ required: true, message: "Please enter the OTP", trigger: "change" }],
});

const rulesStepThree = reactive<FormRules<RegisterFormThree>>({
  mobileNumber: [
    { required: true, message: "Please enter a cellphone number", trigger: "change" },
    { pattern: /^0\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s?$/, message: "Please enter a valid cellphone number (no country code)", trigger: "blur" },
  ],
  email: [{ required: true, type: "email", message: "Please enter a valid email address", trigger: "change" }],
  password: [{ required: true, validator: validatePassword, trigger: "change" }],
  confirmPassword: [{ required: true, validator: validatePassword2, trigger: "change" }],
});

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      console.log("valid");

      switch (currentStep.value) {
        case 'one':{
          formOneData.mobileNumber = formOneData.mobileNumber.replaceAll(' ', '');

          // To restore
          authStore.sendMobileOTP({mobileNumber: formOneData.mobileNumber, orderReferenceNumber: formOneData.orderReferenceNumber}).then((res) => {
            formTwoData.mobileNumber = formOneData.mobileNumber;
            formDetails.two.description = `An OTP has been sent to ${formTwoData.mobileNumber}. Enter the OTP below:`;
            ElMessage.success({ message: "OTP sent!", showClose: true });
            currentStep.value = 'two';
          })
          break;
        }

        case 'two':{
          // To restore
          authStore.verifyOTP({mobileNumber: formTwoData.mobileNumber, otp: formTwoData.otp}).then((res) => {
            formThreeData.mobileNumber = formOneData.mobileNumber;
            formThreeData.customerId = res;
            ElMessage.success({ message: "OTP verfified!", showClose: true });
            currentStep.value = 'three';
          }).catch(() => {
            formTwoData.otp = ""
            currentStep.value = 'one';
          })
          break;
        }

        case 'three':{
          // To restore
          authStore.registerAccount({email: formThreeData.email, password: formThreeData.password, customerId: formThreeData.customerId}).then(() => {
            router.push({ name: 'EmailVerification', query: { sent: 'success' } });
          })
          break;
        }
      
        default:
          break;
      }
    } else {
      handleInvalidForm(fields as ValidateFieldsError)
    }
  });
};

function handleFormError(fields: ValidateFieldsError | undefined) {
  if (fields) {
    let errorMessages = [];
    for (const field in fields) {
      errorMessages.push(`<p class="m-0">${fields[field][0].message}</p>`);
    }
    ElMessage.closeAll();
    ElMessage.error({ message: errorMessages.join(""), showClose: true, dangerouslyUseHTMLString: true, duration: 0 });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode("Register: "),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode("Step " + _toDisplayString(_unref(stepAsNumber)[_unref(currentStep)]) + " of 4", 1),
          _hoisted_4
        ])
      ])
    ]),
    _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(formDetails)[_unref(currentStep)].title), 1),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "mb-3 mb-md-4 pb-1",
        innerHTML: _unref(formDetails)[_unref(currentStep)].description
      }, null, 8, _hoisted_7),
      (_unref(currentStep) == 'one')
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            ref_key: "stepOneFormRef",
            ref: stepOneFormRef,
            model: _unref(formOneData),
            rules: rulesStepOne,
            size: "large",
            "label-position": "top",
            "require-asterisk-position": "right"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_form_item, {
                  class: "col-12 pb-2 mb-3 mb-md-4",
                  label: "Cellphone Number",
                  prop: "mobileNumber"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      name: "mobileNumber",
                      modelValue: _unref(formOneData).mobileNumber,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formOneData).mobileNumber) = $event)),
                      placeholder: "Enter your cellphone number (*)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  class: "col-12 pb-2 mb-3 mb-md-4",
                  label: "Order Reference Number",
                  prop: "orderReferenceNumber"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      name: "orderReferenceNumber",
                      modelValue: _unref(formOneData).orderReferenceNumber,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formOneData).orderReferenceNumber) = $event)),
                      placeholder: "Enter your order reference number (*)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"]))
        : _createCommentVNode("", true),
      (_unref(currentStep) == 'two')
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 1,
            ref_key: "stepTwoFormRef",
            ref: stepTwoFormRef,
            model: _unref(formTwoData),
            rules: rulesStepTwo,
            size: "large",
            "label-position": "top",
            "require-asterisk-position": "right"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_form_item, {
                  class: "col-12 pb-2 mb-3 mb-md-4",
                  label: "OTP",
                  prop: "otp"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      name: "otp",
                      modelValue: _unref(formTwoData).otp,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formTwoData).otp) = $event)),
                      placeholder: "Enter your OTP (*)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"]))
        : (_unref(currentStep) == 'three')
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 2,
              ref_key: "stepThreeFormRef",
              ref: stepThreeFormRef,
              model: _unref(formThreeData),
              rules: rulesStepThree,
              size: "large",
              "label-position": "top",
              "require-asterisk-position": "right"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_form_item, {
                    class: "col-12 pb-2 mb-3 mb-md-4",
                    label: "Cellphone Number",
                    prop: "mobileNumber"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(formThreeData).mobileNumber), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "col-12 pb-2 mb-3 mb-md-4",
                    label: "Email",
                    prop: "email"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        name: "email",
                        type: "email",
                        modelValue: _unref(formThreeData).email,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formThreeData).email) = $event)),
                        placeholder: "Enter your email address (*)"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "col-12 pb-2 mb-3 mb-md-4",
                    label: "Password",
                    prop: "password"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formThreeData).password,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formThreeData).password) = $event)),
                        autocomplete: "new-password",
                        name: "password",
                        type: "password",
                        placeholder: "Enter your password (*)",
                        "show-password": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "col-12 pb-2 mb-3 mb-md-4",
                    label: "Confirm Password",
                    prop: "confirmPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formThreeData).confirmPassword,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formThreeData).confirmPassword) = $event)),
                        autocomplete: "new-password",
                        name: "confirmPassword",
                        type: "password",
                        placeholder: "Confirm your password (*)",
                        "show-password": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_unref(process).refs[_unref(currentStep)].value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (submitForm(_unref(process).refs[_unref(currentStep)].value as FormInstance)))
              }, _toDisplayString(_unref(formDetails)[_unref(currentStep)].submit), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_router_link, {
        class: "small",
        to: { name: 'Login' }
      }, {
        default: _withCtx(() => [
          _createTextVNode("Already registered? Log in")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})